import styled from "styled-components";

export const Container = styled.textarea`
  ${({ theme }) => theme.inputs.base};
  resize: vertical;
`;
